import React from "react"
import {Redirect, Route, Switch} from "react-router-dom"
import {useAuthsState} from "../../app/auths/authsContext"
import ProductEditor from "../../app/product-editor/ProductEditor"
import {ProductEditorTranslationProvider} from "../../app/product-editor/productEditorTranslationContext"
import {EventsList} from "./events-list/EventsList"
import {EVENTS_BASE_URL} from "../../app/Routes"
import {PRODUCT_TYPE_EVENT} from "../../app/baseContext"
import {EventsCalendar} from "./events-calendar/EventsCalendar"
import {EventsOverview} from "./events-overview/EventsOverview"
import ProductDetails from "../../app/product-details/ProductDetails"
import {useMuseumSelectorState} from "../../app/museum-selector/museumSelectorContext"
import {ROLES_VALUES} from "../../app/menu/MuseumSelector"

export const EventsRoutes = () => {
    const {userIsAuthenticated} = useAuthsState()
    const {selectedMuseum} = useMuseumSelectorState()

    const getRoutes = () => {
        if (userIsAuthenticated) {
            return (
                <>
                    <Route exact
                           path={EVENTS_BASE_URL}>
                        {selectedMuseum?.role?.value >= ROLES_VALUES.EDITOR
                            ? <EventsOverview/>
                            : <Redirect to={`${EVENTS_BASE_URL}/list`}/>}
                    </Route>
                    <Route path={`${EVENTS_BASE_URL}/list`}>
                        <EventsList/>
                    </Route>
                    <Route path={`${EVENTS_BASE_URL}/calendar`}>
                        <EventsCalendar/>
                    </Route>
                    <Route path={`${EVENTS_BASE_URL}/:id/details`}>
                        <ProductDetails type={PRODUCT_TYPE_EVENT}/>
                    </Route>
                    <Route path={`${EVENTS_BASE_URL}/:id/edit`}>
                        {selectedMuseum?.role?.value >= ROLES_VALUES.EDITOR
                            ? <ProductEditorTranslationProvider>
                                <ProductEditor type={PRODUCT_TYPE_EVENT}/>
                            </ProductEditorTranslationProvider>
                            : <Redirect to={`${EVENTS_BASE_URL}/list`}/>}
                    </Route>
                </>
            )
        } else {
            return null
        }
    }

    return (
        <Switch>
            {getRoutes()}
        </Switch>
    )
}